import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Checkbox, CHECKBOX_SIZE } from '../../../Checkbox'
import Text from '../../../Text'
import {
  QA_NAME_ADD_CHECKLIST_ITEM_BUTTON,
  QA_NAME_CHECKLIST_ITEM_CHECKBOX,
  QA_NAME_CHECKLIST_ITEM_TEXT,
} from '../RequestProfileTabInternalTasks.constants'
import {
  useRequestProfileTabInternalTasksChecklistItemActions,
  useRequestProfileTabInternalTasksContext,
} from '../RequestProfileTabInternalTasks.hooks'
import { RequestProfileTabInternalTasksChecklistItemForm } from '../RequestProfileTabInternalTasksChecklistItemForm'

import * as styles from './RequestProfileTabInternalTasksChecklistItem.module.css'

function RequestProfileTabInternalTasksChecklistItem({
  checklistId,
  checklistItem,
}) {
  const { t } = useTranslation()

  const { canEdit, canEditDoneChecklistItem } =
    useRequestProfileTabInternalTasksContext()

  const {
    handleCancelEdit,
    handleDelete,
    handleStartEdit,
    handleSubmitEdit,
    handleToggleChecked,
    isEditing,
    isSubmitting,
    isTogglingChecked,
  } = useRequestProfileTabInternalTasksChecklistItemActions({
    checklistId,
    checklistItem,
  })

  const textClassName = classNames({
    [styles.checked]: checklistItem.checked,
    [styles.editable]: canEdit,
  })

  return isEditing ? (
    <RequestProfileTabInternalTasksChecklistItemForm
      initialValue={checklistItem.text}
      isLoading={isSubmitting}
      qaName={QA_NAME_ADD_CHECKLIST_ITEM_BUTTON}
      submitText={t('Modal.SaveBtnKey')}
      onCancel={handleCancelEdit}
      onDelete={handleDelete}
      onSubmit={handleSubmitEdit}
    />
  ) : (
    <div className={styles.RequestProfileTabInternalTasksChecklistItem}>
      <Checkbox
        checked={checklistItem.checked}
        className={styles.checkbox}
        disabled={!canEdit || !canEditDoneChecklistItem || isTogglingChecked}
        qaName={QA_NAME_CHECKLIST_ITEM_CHECKBOX}
        size={CHECKBOX_SIZE.small}
        onChange={handleToggleChecked}
      />
      <Text
        isSecondary
        className={textClassName}
        disabled={!canEdit}
        qaName={QA_NAME_CHECKLIST_ITEM_TEXT}
        onClick={handleStartEdit}
      >
        {checklistItem.text}
      </Text>
    </div>
  )
}

export default RequestProfileTabInternalTasksChecklistItem
